import { recordPath, recordRoute } from '@/shared/registry'

/** Where the license agreement pages live. */
export const licenseAgreementsPath = '/site-management/license-agreements'
export const createLicenseAgreementPath = `${licenseAgreementsPath}/new`
export const licenseAgreementRoute = recordRoute('site-management', 'license-agreements')
export const editLicenseAgreementRoute = `${licenseAgreementRoute}/edit`

/** A license agreement's details page. */
export function licenseAgreementPath(id: string): string {
  return recordPath('site-management', 'license-agreements', id)
}

/** The base of License Agreement Details' slots (`detailsSlots`). */
export const licenseAgreementDetailsSlot = 'site-management.license-agreement-details'

/** The API's license agreement endpoints. */
export const licenseAgreementsApi = '/site-management/v1/license-agreements'

export function licenseAgreementApi(id: string): string {
  return `${licenseAgreementsApi}/${encodeURIComponent(id)}`
}

/** The license agreement an organization's own people must accept. */
export function organizationLicenseAgreementApi(organizationId: string): string {
  return `/site-management/v1/organizations/${encodeURIComponent(organizationId)}/license-agreement`
}

/** The API's endpoints for the caller's own acceptances. */
export const myLicenseAgreementAcceptancesApi = '/site-management/v1/me/license-agreement-acceptances'

/** The organization agreements the caller must accept before they carry on. */
export const myPendingLicenseAgreementsApi = `${myLicenseAgreementAcceptancesApi}/pending`

/** What each license agreement action needs; choosing an organization's own agreement needs read. */
export const readLicenseAgreementsPermission = 'site-management.license-agreements.read'
export const writeLicenseAgreementsPermission = 'site-management.license-agreements.write'
export const deleteLicenseAgreementsPermission = 'site-management.license-agreements.delete'

/** Saving an organization's own agreement, a field of the organization. */
export const writeOrganizationProfilesPermission = 'site-management.organization-profiles.write'
